export enum NotificationType {
  ORDER_CREATED = 'order-created',
  ORDERS_SUBMITTED = 'orders-submitted',
  ORDERS_DECLINED = 'orders-declined',
  ORDER_READY = 'order-ready',
  ORDERGROUP_CREATED = 'ordergroup-created',
  TOKEN_DELETE = 'token-delete'
}
